import { render, staticRenderFns } from "./DCObtainSignature.vue?vue&type=template&id=c2d4c782&"
import script from "./DCObtainSignature.vue?vue&type=script&lang=js&"
export * from "./DCObtainSignature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports